import React from 'react'
import { useTranslation } from 'react-i18next'
import { TEMPLATES } from '../constants'

interface Props {
  type: string
  dataSource: [][]
}

const base = 'f-table-container'
export const SampleTable = (props: Props): JSX.Element => {
  const { t } = useTranslation(['onboarding'])
  const { dataSource } = props
  const totalRecord = dataSource.length - TEMPLATES.rowStartIndex

  const getHeaderIndex = (array: [][]) => {
    return array[TEMPLATES.columnHeaderIndex]
  }
  const getDataRow = (array: [][]) => {
    return array
      .slice(TEMPLATES.rowStartIndex, TEMPLATES.rowEndIndex)
      .map((row) => row.filter((_, i) => i !== 0 && i % 2 != 0))
  }

  return (
    <div className={`${base}`}>
      <p className={`${base}__text-paragraph`}>
        {t('onboarding:confirmation.amount')} {totalRecord}&nbsp;
        {t('onboarding:confirmation.item')}
      </p>

      <div className='table-content'>
        <table>
          <thead>
            <tr>
              {getHeaderIndex(dataSource).map((row, index) => (
                <th key={index}>{row}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {getDataRow(dataSource).map((row, index) => (
              <tr key={index}>
                {row.map((cell, cellIndex) => (
                  <td key={cellIndex}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
